<template>
  <div class="jd-purchase-page">
    <!-- 图片内容区域 -->
    <div class="jd-content">
      <img 
        src="@/assets/img/chineseMedicine/officialaccount.jpg" 
        alt="商品详情"
        class="jd-image"
      />
    </div>
    
    <!-- 底部固定按钮 -->
    <div class="jd-footer">
      <a 
        :href="jdLink" 
        class="jd-purchase-btn"
        @click="handlePurchase"
        target="_blank"
      >
        去购买
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JdPurchase',
  data() {
    return {
      // 京东商品详情页链接
      jdLink: 'https://item.m.jd.com/product/10186190982970.html'
    };
  },
  mounted() {
    document.title = '商品详情';
  },
  methods: {
    /**
     * 处理购买按钮点击
     * 跳转到京东商城
     */
    handlePurchase(e) {
      e.preventDefault();
      
      console.log('跳转到京东商城:', this.jdLink);
      
      // 直接跳转到京东商城链接
      try {
        window.location.href = this.jdLink;
      } catch (error) {
        console.error('跳转失败:', error);
        // 备用方案：使用 a 标签跳转
        const link = document.createElement('a');
        link.href = this.jdLink;
        link.target = '_blank';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          if (document.body.contains(link)) {
            document.body.removeChild(link);
          }
        }, 1000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.jd-purchase-page {
  position: relative;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 70px; /* 为底部按钮留出空间 */
}

.jd-content {
  width: 100%;
  overflow-x: hidden;
  
  .jd-image {
    width: 100%;
    height: auto;
    display: block;
  }
}

.jd-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background: #ffffff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.jd-purchase-btn {
  display: block;
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  text-decoration: none;
  background: linear-gradient(135deg, #07c160 0%, #06ad56 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    background: linear-gradient(135deg, #06ad56 0%, #05994c 100%);
    transform: scale(0.98);
  }
  
  &:hover {
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
  }
}
</style>




// WEBPACK FOOTER //
// src/views/jdPurchase/index.vue